
import { Phone, Video } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface Conversation {
  id: string;
  name: string;
  avatar: string;
  status: "online" | "offline";
  lastMessage: string;
  time: string;
  unread: number;
  userId: string;
}

interface CallDialogsProps {
  showVideoCall: boolean;
  showVoiceCall: boolean;
  conversation: Conversation | undefined;
  onCloseVideoCall: () => void;
  onCloseVoiceCall: () => void;
  onEndCall: () => void;
}

const CallDialogs = ({
  showVideoCall,
  showVoiceCall,
  conversation,
  onCloseVideoCall,
  onCloseVoiceCall,
  onEndCall
}: CallDialogsProps) => {
  const getInitials = (name: string) => {
    if (!name) return "?";
    return name
      .split(' ')
      .filter(word => word.length > 0)
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };

  return (
    <>
      <Dialog open={showVideoCall} onOpenChange={onCloseVideoCall}>
        <DialogContent className="sm:max-w-xl">
          <DialogHeader>
            <DialogTitle>Video Call with {conversation?.name}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center space-y-4 p-4">
            <div className="h-60 w-full bg-gray-800 rounded-lg flex items-center justify-center">
              <Video className="h-12 w-12 text-gray-400" />
            </div>
            <p className="text-center text-gray-500">
              Video call simulation. In a real application, this would connect to a WebRTC service.
            </p>
            <Button 
              variant="destructive" 
              onClick={onEndCall}
              className="rounded-full px-8"
            >
              End Call
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={showVoiceCall} onOpenChange={onCloseVoiceCall}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Voice Call with {conversation?.name}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center space-y-4 p-4">
            <Avatar className="h-24 w-24">
              <AvatarImage src={conversation?.avatar} alt={conversation?.name} />
              <AvatarFallback className="text-3xl">{conversation?.name ? getInitials(conversation.name) : "?"}</AvatarFallback>
            </Avatar>
            <p className="text-xl font-medium">{conversation?.name}</p>
            <p className="text-gray-500">Voice call in progress...</p>
            <div className="flex space-x-2 mt-4">
              <Button 
                variant="destructive" 
                onClick={onEndCall}
                className="rounded-full px-8"
              >
                End Call
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CallDialogs;
